import { render, staticRenderFns } from "./ProductDetailPage.vue?vue&type=template&id=baf583f0&"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports